export enum EdgeStorageKey {
  USER = '@gbs-auth/user',
  SIDEBAR = '@gbs-lms/sidebar-shrunken',
  CLIENT = '@gbs-lms/client-company',
  VIEWCOURSE_PASSCODE = '@gbs-lms/viewcourse-passcode',
}
